<template>
  <v-app>
    <div class="page-container">
      <div class="navbar-container">
        <Navbar
          :title="$t('text_booking')"
          :show-back-button="false"
          showCloseButton
        />
      </div>
      <v-container class="main-container pt-0">
        <v-card elevation="2" class="rounded-lg mb-4 mt-2">
          <v-card-text>
            <div class="d-flex align-center justify-start">
              <div class="image-payment mr-1">
                <div v-if="orderData?.is_paid" class="success--text">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="50" width="50" viewBox="0 0 24 24"><path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" /></svg>
                </div>
                <div v-else-if="orderData?.status === 'X'" class="error--text">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="50" width="50" viewBox="0 0 24 24"><path d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z" /></svg>
                </div>
                <div v-else class="warning--text">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="50" width="50" viewBox="0 0 24 24"><path d="M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z" /></svg>
                </div>
              </div>
              <div class="d-flex flex-column">
                <v-card-title
                  class="pb-0 py-1 font-weight-bold black--text body-1"
                >
                  <!-- {{ orderData?.status === 'Z' ? 'Pembayaran Anda sukses!' : '' }}
                  {{ orderData?.status === 'X' ? 'Pesanan Dibatalkan' : '' }}
                  {{ orderData?.status === 'P' ? 'Menunggu Pembayaran' : '' }} -->
                  {{ orderData?.status_desc }}
                </v-card-title>
                <v-card-text class="pb-1 pt-0">{{
                  orderData?.ftotal_amount
                }}</v-card-text>
              </div>
            </div>
            
            <v-btn
              block
              outlined
              color="primary"
              height="40"
              class="text-none mt-2"
              style="font-weight: 700;"
              @click="handleReOrder"
            >
            {{ $t('text_reorder') }}
            </v-btn>
          </v-card-text>
        </v-card>

        <v-alert v-if="orderData?.is_paid && orderData?.status !== 'X'" text class="alert--">
          <div class="d-flex align-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" height="28" width="28" viewBox="0 0 24 24"><path d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z" /></svg>
            <span class="ml-2 body-2"
              >{{ $t('text_visit_store') }}</span
            >
          </div>
        </v-alert>

        <v-card elevation="2" class="rounded-lg mb-8 mt-4">
          <div class="d-flex align-center justify-start">
            <v-avatar class="ma-3 rounded-lg" size="50" tile>
              <v-img :src="storeData?.logo" style="border-radius: 50px"></v-img>
            </v-avatar>
            <v-card-title class="pb-0 py-0 font-weight-bold">{{
              storeData?.name
            }}</v-card-title>
          </div>
          <v-card-text>
            <v-divider />
            <div class="d-flex flex-column mt-2">
              <div class="d-flex justify-space-between align-center">
                <div class="d-flex flex-column">
                  <span class="text-caption">{{ $t('text_order_no') }}</span>
                  <span class="font-weight-bold" style="font-size: large">{{
                    orderData?.order_no
                  }}</span>
                </div>
                <v-chip class="rounded-lg" small>
                  <svg
                    width="12"
                    height="14"
                    viewBox="0 0 12 14"
                    fill="none"
                    class="mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12 13.6668H2C1.196 13.6668 0 13.1342 0 11.6668V10.3335V8.3335V4.3335V2.3335C0 0.866163 1.196 0.333496 2 0.333496H10.6667C11.402 0.333496 12 0.931496 12 1.66683V9.00016V10.3335V11.0002H11.3333H10.6667H2.008C1.7 11.0082 1.33333 11.1302 1.33333 11.6668C1.33333 12.2035 1.7 12.3255 2.008 12.3335H12V13.6668ZM1.33333 2.3335V4.3335V8.3335V9.66683H10.6667V9.00016V1.66683H2C1.7 1.67483 1.33333 1.79683 1.33333 2.3335ZM9.33333 3.00016H3.33333V4.3335H9.33333V3.00016Z"
                      fill="#272727"
                    />
                  </svg>
                  {{ $t('text_reservation') }}
                </v-chip>
              </div>
              <div class="d-flex justify-space-between align-center mt-2">
                <span class="font-weight-normal">{{ $t('text_order_date') }}</span>
                <span>{{ orderData?.forder_date }}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <v-card elevation="2" class="rounded-lg mb-4 mt-4">
          <div class="d-flex flex-column">
            <div v-for="(item, index) in placeReservation" :key="index">
              <div class="d-flex justify-start">
                <v-avatar class="ma-3 rounded-lg" size="90" tile>
                  <v-img style="border-radius: 10px;" :src="item?.photo_md"></v-img>
                </v-avatar>
                <v-card-text class="d-flex flex-column pl-0">
                  <div class="d-flex justify-space-between align-center">
                    <span class="d-flex align-center font-weight-regular">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#767676" width="14" height="14"
                            class="mr-2" viewBox="0 0 24 24">
                            <path
                                d="M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H6V1H8V3H16V1H18V3H19M19,19V8H5V19H19M9,14V16H7V14H9M13,14V16H11V14H13M17,14V16H15V14H17Z" />
                        </svg>
                        {{ item.freserv_date }}
                    </span>

                    <v-chip class="rounded-lg" small color="primary">
                      <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" fill="currentColor" width="14" height="14"
                        viewBox="0 0 24 24">
                        <path
                          d="M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z" />
                      </svg>
                      {{ item.freserv_time }}
                    </v-chip>
                  </div>
                  <span class="d-flex align-center text-caption">
                    <svg class="mr-2" width="14" height="14" viewBox="0 0 14 11" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M1.9981 0.166687C1.34647 0.166687 0.790305 0.637677 0.682974 1.2804L0.348987 3.2804C0.213248 4.09324 0.840021 4.83335 1.66411 4.83335H2.71382V10.3426C2.71382 10.6137 2.93352 10.8334 3.20453 10.8334C3.44967 10.8334 3.6572 10.6525 3.69066 10.4096L4.09151 7.50002H9.90845L10.3093 10.4096C10.3428 10.6525 10.5503 10.8334 10.7954 10.8334C11.0664 10.8334 11.2861 10.6137 11.2861 10.3426V4.83335H12.3358C13.1599 4.83335 13.7867 4.09324 13.651 3.2804L13.317 1.2804C13.2097 0.637678 12.6535 0.166687 12.0019 0.166687H1.9981ZM9.72476 6.16669L9.5536 4.92434C9.54938 4.89371 9.54731 4.86334 9.54725 4.83335H4.45272C4.45266 4.86333 4.45058 4.89371 4.44636 4.92434L4.27521 6.16669H9.72476ZM1.9981 1.50002L12.0019 1.50002L12.3358 3.50002L1.66411 3.50002L1.9981 1.50002Z"
                        fill="#767676" />
                    </svg>
                    {{ item.layout_item_name }}
                  </span>
                  <span class="d-flex align-center font-weight-regular">
                    <svg
                      class="mr-2"
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.66663 1.83331C6.82863 1.83331 5.33329 3.32865 5.33329 5.16665C5.33329 7.00465 6.82863 8.49998 8.66663 8.49998C10.5046 8.49998 12 7.00465 12 5.16665C12 3.32865 10.5046 1.83331 8.66663 1.83331ZM8.66663 7.16665C7.56396 7.16665 6.66663 6.26931 6.66663 5.16665C6.66663 4.06398 7.56396 3.16665 8.66663 3.16665C9.76929 3.16665 10.6666 4.06398 10.6666 5.16665C10.6666 6.26931 9.76929 7.16665 8.66663 7.16665ZM14.6666 14.5V13.8333C14.6666 11.2606 12.5726 9.16665 9.99996 9.16665H7.33329C4.75996 9.16665 2.66663 11.2606 2.66663 13.8333V14.5H3.99996V13.8333C3.99996 11.9953 5.49529 10.5 7.33329 10.5H9.99996C11.838 10.5 13.3333 11.9953 13.3333 13.8333V14.5H14.6666Z"
                        fill="#767676"
                      />
                    </svg>
                    {{ item?.capacity ?? "-" }} {{ $t('text_persons') }}
                  </span>
                  <div class="price mt-1" style="font-size: 1rem" :style="item?.with_special_price === 1 ? 'color: #7b7b7b!important;text-decoration: line-through' : ''">
                    {{ formatCurrency(item.price, true) }}
                  </div>
                  <div v-if="item?.with_special_price === 1" class="price" style="font-size: 1rem;">
                    {{ formatCurrency(item.special_price, true) }}
                  </div>
                </v-card-text>
              </div>
              <v-divider
                v-if="index < placeReservation.length - 1"
                class="mx-3"
              ></v-divider>
            </div>
          </div>
        </v-card>

        <v-card v-if="orderData?.is_paid" elevation="2" class="rounded-lg mb-4 mt-2">
          <v-card-text>
            <div class="d-flex align-center justify-start mb-2">
              <div class="image-payment mr-1 success--text">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="30" height="30" viewBox="0 0 24 24"><path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" /></svg>
              </div>
              <div class="d-flex flex-column">
                <v-card-text class="pb-0 py-1 black--text body-2">
                  {{ $t('text_bukti_transkasi_telah_dikirimkan_ke') }}
                </v-card-text>
                <v-card-text class="pb-1 pt-0 black--text body-2">
                  {{ getCustomerData?.email !== "" ? getCustomerData?.email : getCustomerData?.phone }}
                </v-card-text>
              </div>
            </div>
            <span class="text-caption">
              {{ $t('text_want_to_send_transaction_proof_again') }}
            </span>
            <div class="form d-flex flex-column mt-1" style="gap: 10px">
              <ValidationObserver
                ref="waForm"
                v-slot="{ invalid, validated, passes, validate }"
                class="d-flex align-center"
              >
                <ValidationProvider
                  v-slot="{ errors, valid }"
                  name="phone"
                  rules="required"
                  tag="div"
                  style="width: 100%"
                >
                  <v-text-field
                    v-model="waForm.phone"
                    outlined
                    single-line
                    label="Whatsapp"
                    placeholder="Whatsapp"
                    type="number"
                    hide-details
                    dense
                    :error-messages="errors"
                  >
                  <template v-slot:prepend-inner>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="#757575" width="24" height="24" viewBox="0 0 24 24"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2M12.05 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.04 20.15C10.56 20.15 9.11 19.76 7.85 19L7.55 18.83L4.43 19.65L5.26 16.61L5.06 16.29C4.24 15 3.8 13.47 3.8 11.91C3.81 7.37 7.5 3.67 12.05 3.67M8.53 7.33C8.37 7.33 8.1 7.39 7.87 7.64C7.65 7.89 7 8.5 7 9.71C7 10.93 7.89 12.1 8 12.27C8.14 12.44 9.76 14.94 12.25 16C12.84 16.27 13.3 16.42 13.66 16.53C14.25 16.72 14.79 16.69 15.22 16.63C15.7 16.56 16.68 16.03 16.89 15.45C17.1 14.87 17.1 14.38 17.04 14.27C16.97 14.17 16.81 14.11 16.56 14C16.31 13.86 15.09 13.26 14.87 13.18C14.64 13.1 14.5 13.06 14.31 13.3C14.15 13.55 13.67 14.11 13.53 14.27C13.38 14.44 13.24 14.46 13 14.34C12.74 14.21 11.94 13.95 11 13.11C10.26 12.45 9.77 11.64 9.62 11.39C9.5 11.15 9.61 11 9.73 10.89C9.84 10.78 10 10.6 10.1 10.45C10.23 10.31 10.27 10.2 10.35 10.04C10.43 9.87 10.39 9.73 10.33 9.61C10.27 9.5 9.77 8.26 9.56 7.77C9.36 7.29 9.16 7.35 9 7.34C8.86 7.34 8.7 7.33 8.53 7.33Z" /></svg>
                  </template>
                </v-text-field>
                </ValidationProvider>
                <v-btn
                  color="primary"
                  :elevation="0"
                  height="40"
                  class="text-none ml-2"
                  @click="handleSendWa"
                >
                  {{ $t('text_send') }}
                </v-btn>
              </ValidationObserver>
              <ValidationObserver
                ref="emailForm"
                v-slot="{ invalid, validated, passes, validate }"
                class="d-flex align-center"
              >
                <ValidationProvider
                  v-slot="{ errors, valid }"
                  name="email"
                  rules="required"
                  tag="div"
                  style="width: 100%"
                >
                  <v-text-field
                    v-model="emailForm.email"
                    outlined
                    single-line
                    label="Email"
                    placeholder="Email"
                    prepend-inner-icon="mdi-email-outline"
                    hide-details
                    dense
                    :error-messages="errors"
                  >
                  <template v-slot:prepend-inner>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="#757575" width="24" height="24" viewBox="0 0 24 24"><path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6M20 6L12 11L4 6H20M20 18H4V8L12 13L20 8V18Z" /></svg>
                  </template>
                </v-text-field>
                </ValidationProvider>
                <v-btn
                  color="primary"
                  :elevation="0"
                  height="40"
                  class="text-none ml-2"
                  :disabled="getLoadingAxiosState || loading_send"
                  @click="handleSendEmail"
                >
                  {{ $t('text_send') }}
                </v-btn>
              </ValidationObserver>
            </div>
          </v-card-text>
        </v-card>

        <div class="payment-detail mb-6 mt-4">
          <span class="font-weight-bold">{{ $t('text_price') }}</span>
          <div class="d-flex justify-space-between align-center mt-2">
            <span class="font-weight-medium">Subtotal</span>
            <v-spacer />
            <span class="font-weight-medium">{{
              orderData?.forder_amount
            }}</span>
          </div>
          <div class="d-flex justify-space-between align-center mt-2">
            <span class="font-weight-medium">{{ $t('text_admin_fee') }}</span>
            <v-spacer />
            <span class="font-weight-medium">{{
              orderData?.ftrans_fee_amount
            }}</span>
          </div>
          <!--<div class="d-flex justify-space-between align-center mt-2">
            <span class="font-weight-medium">Tax</span>
            <v-spacer />
            <span class="font-weight-medium">{{ orderData?.ftax_amount }}</span>
          </div>-->
          <div class="d-flex justify-space-between align-center mt-8">
            <span class="font-weight-medium">Total</span>
            <v-spacer />
            <span class="font-weight-medium">{{
              orderData?.ftotal_amount
            }}</span>
          </div>
          <div class="d-flex justify-space-between align-center">
            <span class="font-weight-medium">{{ $t('text_payment_method') }}</span>
            <v-spacer />
            <span class="font-weight-medium">{{
              orderData?.payment_log?.payment_source === "CREDIT-CARD" ? "Credit Card" : orderData?.payment_log?.payment_type
            }}</span>
          </div>
        </div>

        <v-btn
          block
          outlined
          color="primary"
          height="40"
          class="text-none mb-2"
          rounded
          @click="backToHome"
        >
          {{ $t('text_back_to_menu') }}
        </v-btn>
      </v-container>
      <v-snackbar
        v-model="snackbar.show"
        top
        :multi-line="true"
        color="#E9FBE9"
      >
          <div class="d-flex align-center justify-space-between success--text">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="24" height="24" viewBox="0 0 24 24"><path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" /></svg>
            <span class="ml-2">{{ snackbar.text }}</span>
          </div>
      </v-snackbar>
    </div>
  </v-app>
</template>

<script>
import Navbar from "@/components/Layouts/Navbar.vue";
import { mapGetters } from "vuex";
import { getLayout } from "@/api/layout";
import { getReserVationTime } from '@/api/reservation-time';
import { formatCurrency } from "@/utils/currencyUtils";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { sendReceiptWa, sendReceiptEmail, getSelfOrder } from "@/api/payment";
import { deleteQueryParam, removeAllQueryParams } from '@/utils/customQuery'
import { setQueryParam } from '@/utils/customQuery'
import i18n from "@/plugins/i18n";
export default {
  name: "OrderDetail",
  components: {
    Navbar,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      waForm: {
        phone: "",
      },
      emailForm: {
        email: "",
      },
      snackbar: {
        show: false,
        text: "",
      },
      loading_send: false,
    };
  },
  mounted() {
    this.handleCheckUpdate();
  },
  computed: {
    storeData() {
      return this.$store.getters.getStoreData;
    },
    placeReservation() {
      return this.$store.getters.orderData?.place_reservation ?? [];
    },
    getQueryOrderId() {
      return this.$store.getters.getQueryRouter.find(item => item.key === 'order_id')?.value
    },
    ...mapGetters(["orderData", "getCustomerData", "getLoadingAxiosState"]),
  },
  methods: {
    formatCurrency,
    async handleCheckUpdate() {
      try {
        const { data } = await getSelfOrder(this.getQueryOrderId || this.orderData?.id).then(
          (res) => res.data
        );
        this.$store.dispatch("create_order", data);
        if (data.payment_log) {
          if (data.payment_log.checkout_url) {
            this.$store.dispatch("set_router_data", { name: 'order-detail', params: { order_id: data.id } });
            setQueryParam('page', 'order-detail')
            setQueryParam('order_id', data.id)
          }
        }
      } catch (e) {
        console.log('e', e);
        this.$store.state.show_error = true;
        this.$store.state.error_message = e.string;
        this.$store.state.error_type = e.statusCode;
      } finally {
        this.$store.state.loading_axios = false;
      }
    },
    async handleSendWa() {
      const isValid = await this.$refs.waForm.validate();
      if (isValid) {
        try {
          const { date } = await sendReceiptWa(
            this.orderData?.id,
            this.waForm
          ).then((res) => res.data);
          this.snackbar.text = i18n.t('text_proof_of_payment_sent_to_whatsapp');
          this.snackbar.show = true;
          date && window.open(date?.link, "_blank");
        } catch (e) {
          this.$store.state.show_error = true;
          this.$store.state.error_message = e.string;
          this.$store.state.error_type = e.statusCode;
        } finally {
          this.$store.state.loading_axios = false;
        }
      }
    },
    async handleSendEmail() {
      const isValid = await this.$refs.emailForm.validate();
      if (isValid) {
        // console.log(this.emailForm);
        this.loading_send = true
        try {
          const { date } = await sendReceiptEmail(
            this.orderData?.id,
            this.emailForm
          ).then((res) => res.data);
          this.snackbar.text = date.message;
          this.snackbar.show = true;
        } catch (e) {
          this.$store.state.show_error = true;
          this.$store.state.error_message = e.string;
          this.$store.state.error_type = e.statusCode;
        } finally {
          this.$store.state.loading_axios = false;
          this.loading_send = false
        }
      }
    },
    async handleReOrder() {
      const currentOrder = this.orderData.place_reservation ?? []; // arr
      let newArr = [];
      for (const order of currentOrder) {
        try {
          const bydate = await getReserVationTime({
                          start_date: order?.reserv_date,
                          end_date: order?.reserv_date,
                          show_times: 1,
                          available: 1,
                          resto_layout_id: order?.layout_id,
                        }).then((res) => res.data.data[0]);
          const floor = await getLayout({
                          reserv_date: order?.reserv_date,
                          resto_layout_id: order?.layout_id,
                        }).then((res) => res.data.data[0]);
          const item_floor = floor?.items?.find((i) => i.id === order?.layout_item_id)
          const [jam, menit] = order?.reserv_time?.split(':');

          const reorder = {
              ...item_floor,
              reservation_date: bydate,
              floor: floor,
              reserve_time: order?.reserv_time,
              hour: jam,
              minute: menit
          }
          newArr.push(reorder);
        } catch (e) {
              console.log('handleReOrder', e)
          this.$store.state.show_error = true;
          this.$store.state.error_message = e.string;
          this.$store.state.error_type = e.statusCode;
        } finally {
            this.$store.state.loading_axios = false;
            this.loading_send = false
        }
        
        if (newArr.length === currentOrder.length) {
          this.$store.dispatch("addManyItemReservation", newArr);
          this.$store.dispatch("set_router_data", { name: 'checkout' });
          setQueryParam('page', 'checkout')
          deleteQueryParam('order_id')
        }
      }
    },
    backToHome() {
      removeAllQueryParams()
        this.$store.dispatch("remove_order");
        this.$store.dispatch("removeAllReservation");
    },
  },
};
</script>

<style>
.main-container {
  gap: 0 !important;
}
.v-alert__wrapper {
  display: flex;
  align-items: center;
}
</style>
